import React from 'react';

class Footer extends React.Component {
    render(){
        return(
            <footer className="weather-channel__footer">
                <p>Powered by React</p>
            </footer>
        )
    }
}

export default Footer;